/** ListDaily small-screen column settings — shared reference for other List* tabs. */
export const LIST_DAILY_STATISTICS_COLUMN_WIDTH_MULTIPLIER = 1.3;
export const LIST_DAILY_FULL_SCREEN_STATISTICS_COLUMN_WIDTH_MULTIPLIER = 0.5;

const INDICATORS_HEADER_LABEL = 'Indicators';
const LIST_DAILY_LONGEST_NORMAL_LABEL = 'Change % (PM)';
const LIST_DAILY_EDIT_MODE_LABEL = 'Latest/Last Close';

/**
 * Matches the Daily tab's first-column width on small screens (< 640px),
 * for both normal and full-screen table views.
 */
export function getListDailySmallScreenIndicatorsColumnWidth(
  isEditingTickers: boolean,
  isFullScreen: boolean,
  options?: {
    statisticsColumnWidthMultiplier?: number;
    fullScreenStatisticsColumnWidthMultiplier?: number;
  }
): number {
  const statisticsMultiplier =
    options?.statisticsColumnWidthMultiplier ?? LIST_DAILY_STATISTICS_COLUMN_WIDTH_MULTIPLIER;
  const fullScreenMultiplier =
    options?.fullScreenStatisticsColumnWidthMultiplier ??
    LIST_DAILY_FULL_SCREEN_STATISTICS_COLUMN_WIDTH_MULTIPLIER;

  if (isFullScreen) {
    return 120 * fullScreenMultiplier * 0.75;
  }

  const effectiveLabel = isEditingTickers
    ? LIST_DAILY_EDIT_MODE_LABEL
    : LIST_DAILY_LONGEST_NORMAL_LABEL;
  const labelLen = Math.max(INDICATORS_HEADER_LABEL.length, effectiveLabel.length);

  const compactBaseWidth = labelLen * 7.5;
  const compactEditButtonSpace = isEditingTickers ? 16 : 0;
  const compactWidth = compactBaseWidth + 32 + compactEditButtonSpace + 12;

  return Math.max(140, compactWidth * statisticsMultiplier);
}
